<script setup lang="ts">
import { ref, computed, watch } from 'vue';

interface Props {
  formData: {
    time_condition: {
      days_of_week: string[];
      start_time: string;
      end_time: string;
    };
  };
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:formData': [value: any];
}>();

const hasTimeCondition = ref(false);

const formData = computed({
  get: () => props.formData,
  set: (value) => emit('update:formData', value)
});

const daysOfWeek = [
  { value: 'monday', label: 'Lun' },
  { value: 'tuesday', label: 'Mar' },
  { value: 'wednesday', label: 'Mié' },
  { value: 'thursday', label: 'Jue' },
  { value: 'friday', label: 'Vie' },
  { value: 'saturday', label: 'Sáb' },
  { value: 'sunday', label: 'Dom' }
];

watch(hasTimeCondition, (value) => {
  if (!value) {
    formData.value.time_condition = { days_of_week: [], start_time: '', end_time: '' };
  }
});
</script>

<template>
  <div class="border-t border-gray-200 dark:border-gray-700 pt-6">
    <h4 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
      Condiciones de Tiempo
    </h4>
    
    <div class="space-y-3">
      <div>
        <label class="flex items-center">
          <input
            v-model="hasTimeCondition"
            type="checkbox"
            class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          >
          <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Aplicar condiciones de tiempo
          </span>
        </label>
      </div>

      <div
        v-if="hasTimeCondition"
        class="space-y-3"
      >
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Días de la Semana
          </label>
          <div class="grid grid-cols-7 gap-2">
            <label
              v-for="day in daysOfWeek"
              :key="day.value"
              class="flex items-center"
            >
              <input
                :checked="formData.time_condition.days_of_week.includes(day.value)"
                type="checkbox"
                class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                @change="
                  ($event.target as HTMLInputElement).checked 
                    ? formData.time_condition.days_of_week.push(day.value)
                    : formData.time_condition.days_of_week = formData.time_condition.days_of_week.filter(d => d !== day.value)
                "
              >
              <span class="ml-1 text-xs text-gray-700 dark:text-gray-300">{{ day.label }}</span>
            </label>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Hora de Inicio
            </label>
            <input
              :value="formData.time_condition.start_time"
              type="time"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              @input="formData.time_condition.start_time = ($event.target as HTMLInputElement).value"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Hora de Fin
            </label>
            <input
              :value="formData.time_condition.end_time"
              type="time"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              @input="formData.time_condition.end_time = ($event.target as HTMLInputElement).value"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
